/* Defines the application toolbar */
import * as React from "react";
import { action, observable } from "mobx";
import { inject, observer } from "mobx-react";
import SeekerStore from "../../../stores/seekerStore";
import { ILocalization, ISupportedLanguage } from "../../../models/localization";
import LanguageDlg from "../../dialogs/language";
import { hashHistory } from "react-router";
import { Auth } from "../../../utils/auth";
import { ScreenMode } from "../../../models/enums";
import BottomNavigation, { BottomNavigationAction } from 'material-ui/BottomNavigation';
import LoginDlg from "../../dialogs/login";
import AppBar from "material-ui/AppBar";
import Toolbar from "material-ui/Toolbar";
import IconButton from "material-ui/IconButton";
import MenuIcon from "material-ui-icons/Menu";
import Button from "material-ui/Button";
import Tooltip from "material-ui/Tooltip";
import RestoreIcon from 'material-ui-icons/Restore';
import FavoriteIcon from 'material-ui-icons/Favorite';
import Menu, { MenuItem } from 'material-ui/Menu';
import LogOffIcon from "material-ui-icons/ExitToApp";
import LocationOnIcon from 'material-ui-icons/LocationOn';
import SideBar from "../sidebar";
import * as s from "./bar.css";
import TextField from 'material-ui/TextField';
import Input, { InputLabel } from 'material-ui/Input';
import { FormControl, FormHelperText } from 'material-ui/Form';
import Select from 'material-ui/Select';

const styles = {
  MuiIconButton: {
    color: "#5B6770",
    zIndex: 1,
  },
  labelStyle: {
    paddingLeft: "4px",
    paddingRight: "4px",
  },
  appBar: {
    backgroundColor: "#f6f8f8",
  }
}

@observer
export default class NavBar extends React.Component<{ store: SeekerStore }, {}> {

  @observable language:string;
  @observable showLang: boolean;

  constructor(props: any) {
    super(props);
    this.language = "";
    this.showLang = false;
  }
  @action toggleLangMenu = (e: any): void => {
    this.showLang = !this.showLang;
  }
  @action setLanguage = (lang: string): void => {
    if (lang !== this.props.store.localization.language) {
      this.props.store.localization.language = lang;
    }
    this.showLang = false;
  }
  @action handleClose = (): void => {
    this.showLang = false;
  }
  renderFullscreen(): JSX.Element[] {
    const local: ILocalization = this.props.store.localization.fields;
    const langs: JSX.Element[] = [];
    local.nav.languages.map((lang: ISupportedLanguage, i:number): void => {
      langs.push(<MenuItem key={i} selected={this.props.store.localization.language === lang.value} onClick={() => this.setLanguage(lang.value)}>{lang.name}</MenuItem>);
    });
    const items: JSX.Element[] = [];
    if (!Auth.isAuthenticated) {
      items.push(<Button className={s.button} key="lang" id="lang-root" style={styles.labelStyle} onClick={this.toggleLangMenu} ><img src={local.icons.lifeExperience} width="24px" height="auto" /></Button >);
      items.push(<Menu key="lang-list" id="langPicker" anchorEl={document.getElementById("lang-root")} open={this.showLang} onClose={this.handleClose}>
        {langs}
      </Menu>);
      //items.push(<Button className={s.button} key="help" style={styles.labelStyle} onClick={() => hashHistory.push("/help")}>{local.sideNav.help}</Button>)
      items.push(<Button className={s.button} key="register" onClick={() => this.props.store.viewState.setShowRegister(true)} style={styles.labelStyle} > {local.nav.register}</Button>)
      items.push(<Button className={s.button} key="login" onClick={() => this.props.store.viewState.setShowLogin(true)} style={styles.labelStyle} > {local.nav.login}</Button>);
    } else {
      items.push(<Button className={s.button} key="lang" id="lang-root" style={styles.labelStyle} onClick={this.toggleLangMenu} ><img src={local.icons.lifeExperience}  width="24px" height="auto" /></Button >);
      items.push(<Menu key="lang-list" id="langPicker" anchorEl={document.getElementById("lang-root")} open={this.showLang} onClose={this.handleClose}>
        {langs}
      </Menu>);
    }
    return items;
  }

  renderMobileSideBar(): JSX.Element[] {
    let local: ILocalization = this.props.store.localization.fields;
    let items: JSX.Element[] = [];
      items.push(<IconButton key="navbar-menu" style={styles.MuiIconButton} aria-label="Menu" onClick={this.props.store.viewState.toggleDrawer}><MenuIcon /></IconButton>)
      items.push(<SideBar key="navbar-sliding-drawerer" store={this.props.store} />);

    return items;
  }

  render(): JSX.Element {

    const imgUrl: string = this.props.store.localization.fields.nav.navLogo || "images/ss-logo-lg.png";
  const logoAlt: string = this.props.store.localization.fields.nav.navLogoAlt || "SkillSmart Logo";
  const logoToolTip: string = this.props.store.localization.fields.nav.logoToolTip || "Take me Home";
  const mode: ScreenMode = this.props.store.viewState.screenMode;

  return <AppBar style={styles.appBar} position="static">
    <Toolbar>
      {mode === ScreenMode.Mobile && this.renderMobileSideBar()}
      <div className={s.branding}>
        <Tooltip id="tooltip-home" title={logoToolTip}><img className={s.logo} src={imgUrl} alt={logoAlt} onClick={() => hashHistory.push("/home")} /></Tooltip>
        <br /><p className={s.tagline}>{this.props.store.localization.fields.tagline}</p>
      </div>
      <div style={{ flex: 1 }}>
        {mode !== ScreenMode.Mobile && this.renderFullscreen()}
        { /*{mode === ScreenMode.Mobile && this.renderMobileNavBar()}*/}
      </div>
      {mode === ScreenMode.Mobile && <LanguageDlg store={this.props.store}/>}
    </Toolbar>
  </AppBar>

  }
}


// WEBPACK FOOTER //
// ./src/components/app/navbar/index.tsx